import { takeEvery } from 'redux-saga/effects';
import Services from 'services';
import types from 'redux/types';
import { V2_LOGOUT_URL } from 'consts/api';
import { AppRoutes } from 'consts/routesPath';
import Broadcast from 'services/BroadcastChannel';
import UserServices from 'services/UserServices';
import CacheService from 'services/CacheService';

const { REQUEST_API_LOGOUT } = types;

function* postLogout({ to, forceClearAll }) {
  const userInfo = CacheService.userInfo;
  const { username, isSuperAdmin } = userInfo || {};

  yield Services.post(V2_LOGOUT_URL);
  const rootUser = UserServices.getRootUser();
  //* Checking
  //* - if rootUser is empty blank -> this account not login as
  //* - if username === rootUser -> you just back to root user -> need clear all info of account when excute logout
  const shouldClearAllThings = !rootUser || username === rootUser || isSuperAdmin;

  if (forceClearAll || shouldClearAllThings) {
    UserServices.clearUserCached();
  }

  Broadcast.channelSwitchUser().postMessageReload();
  window.location.href = to || AppRoutes.Login;
}

export default function* watchGetAPIFunction() {
  yield takeEvery(REQUEST_API_LOGOUT, postLogout);
}
